<template>
  <footer class="site-footer">
    <div class="container footer-inner">
      <nav class="footer-grid" aria-label="底部导航">
        <div v-for="group in footerGroups" :key="group.title" class="footer-column">
          <h2>{{ group.title }}</h2>
          <router-link v-for="link in group.links" :key="`${group.title}-${link.label}`" :to="link.path">
            {{ link.label }}
          </router-link>
        </div>
      </nav>
      <div class="footer-qrcode">
        <img src="../../assets/image/footer-qrcode.jpg" alt="千讯云创服务号二维码">
        <span>千讯云创服务号</span>
      </div>
    </div>
    <a href="https://beian.miit.gov.cn/#/Integrated/index" class="copyright">粤ICP备2024214847号</a>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      footerGroups: [
        {
          title: '关于我们',
          links: [
            { label: '公司介绍', path: '/about#company' },
            { label: '研发团队', path: '/about#team' },
            { label: '技术实力', path: '/about#team' },
            { label: '全球数据', path: '/about#global' },
            { label: '资质证书', path: '/about#certification' }
          ]
        },
        {
          title: '解决方案',
          links: [
            { label: '车辆位置追踪', path: '/services#vehicle' },
            { label: '智慧人员定位', path: '/services#people' },
            { label: '畜牧/宠物定位', path: '/services#livestock' },
            { label: '汽车金融风控', path: '/services#finance' }
          ]
        },
        {
          title: '产品中心',
          links: [
            { label: '外贸跨境系列', path: '/cases#cross-border' },
            { label: '智能安全守护', path: '/cases#security' },
            { label: '定制化定位器', path: '/cases#customized' },
            { label: '4G全球通系列', path: '/cases#global-4g' }
          ]
        },
        {
          title: '平台介绍',
          links: [
            { label: '平台简介', path: '/news#intro' },
            { label: '平台实力', path: '/news#strength' },
            { label: '定制平台', path: '/news#private' },
            { label: '研发团队', path: '/news#team' }
          ]
        },
        {
          title: '人才招聘',
          links: [
            { label: '代理流程', path: '/talent#process' },
            { label: '加入我们', path: '/talent#join' }
          ]
        },
        {
          title: '联系我们',
          links: [
            { label: '公司信息', path: '/contact#info' },
            { label: '公司地址', path: '/contact#map' }
          ]
        }
      ]
    }
  }
}
</script>
